import callAccountsApi from '../data-provider'
const Moment = require('moment')

if (!callAccountsApi) {
  callAccountsApi = require('../data-provider').callAccountsApi
}

const importStarling = async (account, sourceAccount, data) => {
  console.log("Importing Starling", account)

  let rows = data.split("\n").map(r => r.trim()).filter(r => r.length)

  if (rows.length && rows[0].toLowerCase().startsWith("date,"))
  {
    rows = rows.slice(1)
  }

  const starlingTypes = await callAccountsApi("transactions", "getStarlingTransactionTypes")

  let parsedRows = rows
    .map(row => row.split(','))
    .filter(row => row[0] && Moment(row[0], "DD/MM/YYYY", true).isValid())
    .sort((a, b) => Moment(a[0], "DD/MM/YYYY").valueOf() - Moment(b[0], "DD/MM/YYYY").valueOf())

  if (!parsedRows.length)
  {
    return []
  }

  let vatRate = null
  let firstVatRow = parsedRows.find(row => {
    let mappedType = getMappedType(starlingTypes, row[6])
    return mappedType && mappedType.apply_vat
  })

  if (firstVatRow)
  {
    vatRate = await callAccountsApi("invoices", "getVATRate", {
      date: Moment(firstVatRow[0], "DD/MM/YYYY", true).format("YYYY-MM-DD")
    })
  }

  let transactions = parsedRows.map(row => buildTransaction(account, starlingTypes, row, vatRate))
    .filter(Boolean)

  if (!transactions.length)
  {
    return []
  }

  await callAccountsApi("transactions", "insertTransactions", { transactions })

  return transactions
}

const toStarlingCategoryLabel = value => {
  let text = (value || '').toString().trim().toLowerCase().replace(/_/g,' ')
  text = text.replace(/\band\b/g,'&')
  return text.replace(/\b\w/g, c => c.toUpperCase())
}

const normaliseKey = value => (value || '').toString().trim().toUpperCase().replace(/[^A-Z0-9]/g,'')

const getMappedType = (starlingTypes, rawCategory) => {
  let categoryLabel = toStarlingCategoryLabel(rawCategory)

  return starlingTypes[rawCategory] ||
    starlingTypes[categoryLabel] ||
    starlingTypes[normaliseKey(rawCategory)] ||
    starlingTypes[normaliseKey(categoryLabel)]
}

const calculateVatFromGross = (grossAmount, rate) => {
  if (!rate)
  {
    return 0
  }

  return parseFloat(((grossAmount * rate) / (1 + rate)).toFixed(2))
}

const buildTransaction = (account, starlingTypes, row, vatRate) => {
  if (!row[0] || !row[0].trim())
  {
    return null
  }

  if (!row[1] && !row[2] && !row[3] && !row[4] && !row[5] && !row[6])
  {
    return null
  }

  let transactionDate = Moment(row[0], "DD/MM/YYYY", true)
  if (!transactionDate.isValid())
  {
    return null
  }

  let mappedType = getMappedType(starlingTypes, row[6])

  let amount = parseFloat(row[4], 10)
  if (Number.isNaN(amount))
  {
    return null
  }

  let transaction = {
    account_id: account.account_id,
    transaction_date: transactionDate.format("YYYY-MM-DD"),
    transaction_type_id: mappedType ? mappedType.transaction_type_id : 27,
    notes: row[1],
    long_note: row[2]
  }

  if (amount > 0)
  {
    transaction.amount_in = amount
  }
  else
  {
    transaction.amount_out = amount * -1
  }

  if (mappedType && mappedType.apply_vat && vatRate !== null)
  {
    transaction.vat = calculateVatFromGross(Math.abs(amount), vatRate)
  }

  return transaction
}

export default importStarling
